module.exports = __webpack_public_path__ + "img/qrcode-1054.7f5fd1b9.png";